<div class="filter-container container">
  <div class="c-date-picker">
    <div>{{ 'label.From' | translate }}</div>
    <p-datepicker
      [showIcon]="true"
      [(ngModel)]="filterPagingWrapper.filter.createDate.from"
    ></p-datepicker>
  </div>
  <div class="c-date-picker">
    <div>{{ 'label.To' | translate }}</div>
    <p-datepicker
      [showIcon]="true"
      [(ngModel)]="filterPagingWrapper.filter.createDate.to"
    ></p-datepicker>
  </div>
  <div>
    <div>{{ 'label.Customer' | translate }}</div>
    <div>
      <input type="text" [(ngModel)]="filterPagingWrapper.filter.customer" />
    </div>
  </div>
  <div>
    <div>
      <input
        type="checkbox"
        [(ngModel)]="filterPagingWrapper.filter.isHiddenZeroAnnouncement"
      />
    </div>
    <div>{{ 'label.HideCompaniesWithZeroTotalAnnouncements' | translate }}</div>
  </div>
  <div>
    <div>
      <input
        type="checkbox"
        [(ngModel)]="filterPagingWrapper.filter.isHiddenZeroTotalDebt"
      />
    </div>
    <div>{{ 'label.HideCompaniesWithZeroTotalDebt' | translate }}</div>
  </div>

  <div>
    <button class="apply" (click)="onApplyClick(dt)">
      {{ 'label.Filter' | translate }}
    </button>
    <button class="clear" (click)="onClearClick()">
      {{ 'label.Clear' | translate }}
    </button>
  </div>
  <p-button
    type="button"
    class="ui-button-secondary"
    [disabled]="selectedCustomers?.length == 0"
    (click)="onCompanyMove()"
    [style]="{'float': 'right'}"
    label="{{ 'label.Move' | translate }}"
  ></p-button>
</div>
<div class="table">
  <hr-portfolio-customer-move
    [display]="displayMove"
    [currentPortfolioId]="portfolio.portfolioId"
    [customers]="selectedCustomers"
    (onUpdate)="onUpdateTable($event)"
  ></hr-portfolio-customer-move>
  <hr-thread-post-editor
    [threadId]="displayedOrEditingThreadId"
    [objectTypeId]="ThreadRelatedObjectTypeEnum.Customer"
    [objectId]="editingThreadObjectId"
    [topicId]="displayedOrEditingThreadTopic"
    [channelId]="PostingChannelEnum.Common"
    [display]="displayThreadPostEditor"
    (onUpdate)="onUpdateTable($event)"
  ></hr-thread-post-editor>
  <hr-thread-view
    [threadId]="displayedOrEditingThreadId"
    [display]="displayThread"
    [topicId]="displayedOrEditingThreadTopic"
    (onClose)="onThreadClose($event)"
    (onDeleteComment)="onPostDelete($event)"
  ></hr-thread-view>
  <div style="text-align: left">
    <p-multiSelect
      [options]="columnGroups"
      [(ngModel)]="selectedColumnGroups"
      optionLabel="header"
      (onChange)="onColumnsDropdownChange($event)"
      selectedItemsLabel="{0} columns selected"
      [style]="{ minWidth: '200px' }"
      defaultLabel="Hide/Show columns"
    ></p-multiSelect>
  </div>
  <p-table
    [hidden]="selectedColumnGroups.length == 0"
    showGridlines
    [value]="customerDetails"
    #dt
    [(selection)]="selectedCustomers"
    [lazy]="true"
    [paginator]="true"
    [rows]="pageSize"
    [rowsPerPageOptions]="[20, 50, 100]"
    (onLazyLoad)="onLoad($event)"
    [totalRecords]="totalRecords"
    dataKey="customerId"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th rowspan="2" style="width: 3em">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th
          colspan="3"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]"
        >
          Customer info
        </th>
        <th
          colspan="6"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"
        >
          Quantity
        </th>
        <th
          colspan="6"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"
        >
          Amount
        </th>
        <th
          colspan="4"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"
        >
          Comments
        </th>
      </tr>
      <tr>
        <th
          [pSortableColumn]="'name'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]"
        >
          {{ 'label.Company' | translate }}
          <p-sortIcon
            [field]="'name'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th
          [pSortableColumn]="'date'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]"
        >
          {{ 'label.Date' | translate }}
          <p-sortIcon
            [field]="'date'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th
          [pSortableColumn]="'contract'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]"
        >
          {{ 'label.Contract' | translate }}
          <p-sortIcon
            [field]="'contract'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'totalAnnouncements'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"
        >
          {{ 'label.TotalAnnouncements_portfolio' | translate }}
          <p-sortIcon
            [field]="'totalAnnouncements'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th
          [pSortableColumn]="'paidAnnouncements'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"
        >
          {{ 'label.PaidAnnouncements_portfolio' | translate }}
          <p-sortIcon
            [field]="'paidAnnouncements'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th
          [pSortableColumn]="'freeAnnouncements'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"
        >
          {{ 'label.Free' | translate }}
          <p-sortIcon
            [field]="'freeAnnouncements'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th
          [pSortableColumn]="'totalDbProducts'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"
        >
          {{ 'label.CvDatabase' | translate }}
          <p-sortIcon
            [field]="'totalDbProducts'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th
          [pSortableColumn]="'totalSlider'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"
        >
          {{ 'label.Slider' | translate }}
          <p-sortIcon
            [field]="'totalSlider'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th
          [pSortableColumn]="'totalCvBoxProducts'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"
        >
          {{ 'label.CvBox' | translate }}
          <p-sortIcon
            [field]="'totalCvBoxProducts'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'totalAmount'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"
        >
          {{ 'label.TotalAmount' | translate }}
          <p-sortIcon
            [field]="'totalAmount'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'totalInvoiceAmount'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"
        >
          {{ 'label.TotalInvoiceAmount' | translate }}
          <p-sortIcon
            [field]="'totalInvoiceAmount'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'totalPayments'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"
        >
          {{ 'label.TotalPayments' | translate }}
          <p-sortIcon
            [field]="'totalPayments'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'currentDebt'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"
        >
          {{ 'label.CurrentDebt' | translate }}
          <p-sortIcon
            [field]="'currentDebt'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'oldDebt'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"
        >
          {{ 'label.OldDebt' | translate }}
          <p-sortIcon
            [field]="'oldDebt'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'totalDebt'"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"
        >
          {{ 'label.TotalDebt' | translate }}
          <p-sortIcon
            [field]="'totalDebt'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'threadTopic,' + ThreadTopicEnum.Sales"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"
        >
          {{ 'label.Sales' | translate }}
          <p-sortIcon
            [field]="'threadTopic,' + ThreadTopicEnum.Sales"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'threadTopic,' + ThreadTopicEnum.Manager"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"
          style="max-width: 100px"
        >
          {{ 'label.Manager' | translate }}
          <p-sortIcon
            [field]="'threadTopic,' + ThreadTopicEnum.Manager"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'threadTopic,' + ThreadTopicEnum.ACC"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"
          style="width: 100px"
        >
          {{ 'label.ACC' | translate }}
          <p-sortIcon
            [field]="'threadTopic,' + ThreadTopicEnum.ACC"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th
          [pSortableColumn]="'threadTopic,' + ThreadTopicEnum.Debt"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"
          style="width: 100px"
        >
          {{ 'label.DC' | translate }}
          <p-sortIcon
            [field]="'threadTopic,' + ThreadTopicEnum.Debt"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template
      pTemplate="body"
      let-customerRecord
      let-expanded="expanded"
      let-columns="columns"
    >
      <tr [pSelectableRow]="customerRecord">
        <td>
          <p-tableCheckbox [value]="customerRecord"></p-tableCheckbox>
        </td>

        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]">
          <a [routerLink]="['/customers/view', customerRecord?.customerId]">{{
            customerRecord.customerName
          }}</a>
          <br />
          {{ customerRecord.customerTaxCode }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]">
          {{ customerRecord.customerCreateDate | date : dateFormat }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]">
          {{ customerRecord.contract?.type?.name }}
        </td>

        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
          {{ customerRecord.totalAnnouncements }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
          {{ customerRecord.paidAnnouncements }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
          {{ customerRecord.freeAnnouncements }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
          {{ customerRecord.totalDbProducts }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
          {{ customerRecord.totalSlider }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
          {{ customerRecord.totalCvBoxProducts }}
        </td>

        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
          {{ customerRecord.totalAmount | number : decimalFormat }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
          <a
            [routerLink]="[
              '/billing/invoices/list',
              { customer: customerRecord?.customerTaxCode }
            ]"
            target="_blank"
            >{{ customerRecord.totalInvoiceAmount | number : decimalFormat }}</a
          >
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
          <a
            [routerLink]="[
              '/billing/payments/list',
              { customer: customerRecord?.customerTaxCode }
            ]"
            target="_blank"
            >{{ customerRecord.totalPayments | number : decimalFormat }}</a
          >
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
          <a
            [routerLink]="[
              '/billing/invoices/list',
              { status: '1', customer: customerRecord?.customerTaxCode }
            ]"
            target="_blank"
            >{{ customerRecord.currentDebt | number : decimalFormat }}</a
          >
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
          {{ customerRecord.oldDebt | number : decimalFormat }}
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
          {{ customerRecord.totalDebt | number : decimalFormat }}
        </td>

        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]">
          <span
            class="comment"
            (click)="
              showThread(
                customerRecord.lastComments[ThreadTopicEnum.Sales]?.threadId,
                ThreadTopicEnum.Sales
              )
            "
          >
            {{ customerRecord.lastComments[ThreadTopicEnum.Sales]?.text }}
          </span>
          <span>{{
            customerRecord.lastComments[ThreadTopicEnum.Sales]?.createDate
              | date : dateFormat
          }}</span>
          <p-button
            type="button"
            class="addComment"
            icon="fa fa-plus-circle"
            (click)="
              showCommentEditor(
                customerRecord.lastComments[ThreadTopicEnum.Sales]?.threadId,
                customerRecord.customerId,
                ThreadTopicEnum.Sales
              )
            "
          ></p-button>
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]">
          <span
            class="comment"
            (click)="
              showThread(
                customerRecord.lastComments[ThreadTopicEnum.Manager]?.threadId,
                ThreadTopicEnum.Manager
              )
            "
          >
            {{ customerRecord.lastComments[ThreadTopicEnum.Manager]?.text }}
          </span>
          <span>{{
            customerRecord.lastComments[ThreadTopicEnum.Manager]?.createDate
              | date : dateFormat
          }}</span>
          <p-button
            type="button"
            class="addComment"
            icon="fa fa-plus-circle"
            (click)="
              showCommentEditor(
                customerRecord.lastComments[ThreadTopicEnum.Manager]?.threadId,
                customerRecord.customerId,
                ThreadTopicEnum.Manager
              )
            "
          ></p-button>
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]">
          <span
            class="comment"
            (click)="
              showThread(
                customerRecord.lastComments[ThreadTopicEnum.ACC]?.threadId,
                ThreadTopicEnum.ACC
              )
            "
          >
            {{ customerRecord.lastComments[ThreadTopicEnum.ACC]?.text }}
          </span>
          <span>{{
            customerRecord.lastComments[ThreadTopicEnum.ACC]?.createDate
              | date : dateFormat
          }}</span>
          <p-button
            type="button"
            class="addComment"
            icon="fa fa-plus-circle"
            (click)="
              showCommentEditor(
                customerRecord.lastComments[ThreadTopicEnum.ACC]?.threadId,
                customerRecord.customerId,
                ThreadTopicEnum.ACC
              )
            "
          ></p-button>
        </td>
        <td [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]">
          <span
            class="comment"
            (click)="
              showThread(
                customerRecord.lastComments[ThreadTopicEnum.Debt]?.threadId,
                ThreadTopicEnum.Debt
              )
            "
          >
            {{ customerRecord.lastComments[ThreadTopicEnum.Debt]?.text }}
          </span>
          <span>{{
            customerRecord.lastComments[ThreadTopicEnum.Debt]?.createDate
              | date : dateFormat
          }}</span>
          <p-button
            type="button"
            class="addComment"
            icon="fa fa-plus-circle"
            (click)="
              showCommentEditor(
                customerRecord.lastComments[ThreadTopicEnum.Debt]?.threadId,
                customerRecord.customerId,
                ThreadTopicEnum.Debt
              )
            "
          ></p-button>
        </td>
      </tr>
    </ng-template>

    <!-- <p-headerColumnGroup>
      <p-row>
        <p-column rowspan="2" selectionMode="multiple" [style]="{'width':'38px'}"></p-column>
        <p-column header="Customer info" colspan="3" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]"></p-column>
        <p-column header="Quantity" colspan="6" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"></p-column>
        <p-column header="Amount" colspan="6" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"></p-column>
        <p-column header="Comments" colspan="4" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"></p-column>
      </p-row>
      <p-row>
        <p-column header="{{'label.Company' | translate}}" field="name" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]"></p-column>
        <p-column header="{{'label.Date' | translate}}" [sortable]="true" [style]="{'width':'90px'}" field="date" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]"></p-column>
        <p-column header="{{'label.Contract' | translate}}" field="contract" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]"></p-column>
        <p-column header="{{'label.TotalAnnouncements_portfolio' | translate}}" field="totalAnnouncements" [sortable]="true"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"></p-column>
        <p-column header="{{'label.PaidAnnouncements_portfolio' | translate}}" field="paidAnnouncements" [sortable]="true"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"></p-column>
        <p-column header="{{'label.Free' | translate}}" field="freeAnnouncements" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"></p-column>
        <p-column header="{{'label.CvDatabase' | translate}}" field="totalDbProducts" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"></p-column>
        <p-column header="{{'label.Slider' | translate}}" field="totalSlider" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"></p-column>
        <p-column header="{{'label.CvBox' | translate}}" field="totalCvBoxProducts" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]"></p-column>
        <p-column header="{{'label.TotalAmount' | translate}}" field="totalAmount" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"></p-column>
        <p-column header="{{'label.TotalInvoiceAmount' | translate}}" field="totalInvoiceAmount" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"></p-column>
        <p-column header="{{'label.TotalPayments' | translate}}" field="totalPayments" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"></p-column>
        <p-column header="{{'label.CurrentDebt' | translate}}" field="currentDebt" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"></p-column>
        <p-column header="{{'label.OldDebt' | translate}}" field="oldDebt" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"></p-column>
        <p-column header="{{'label.TotalDebt' | translate}}" field="TotalDebt" [sortable]="true" [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]"></p-column>
        <p-column header="{{'label.Sales' | translate}}" field="{{'threadTopic,' + ThreadTopicEnum.Sales}}" [sortable]="true"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"></p-column>
        <p-column header="{{'label.Manager' | translate}}" field="{{'threadTopic,' + ThreadTopicEnum.Manager}}" [sortable]="true"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"></p-column>
        <p-column header="{{'label.ACC' | translate}}" field="{{'threadTopic,' + ThreadTopicEnum.ACC}}" [sortable]="true"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"></p-column>
        <p-column header="{{'label.DC' | translate}}" field="{{'threadTopic,' + ThreadTopicEnum.Debt}}" [sortable]="true"
          [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]"></p-column>
      </p-row>
    </p-headerColumnGroup>

    <p-column selectionMode="multiple"></p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        <a [routerLink]="['/customers/view',customerRecord?.customerId]">{{customerRecord.customerName}}</a>
        <br>
        {{customerRecord.customerTaxCode}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.customerCreateDate | date:dateFormat}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.CustomerInfo]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.contract?.type?.name}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.totalAnnouncements}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.paidAnnouncements}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.freeAnnouncements}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.totalDbProducts}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.totalSlider}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Quantity]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.totalCvBoxProducts}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.totalAmount | number:decimalFormat}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        <a [routerLink]="['/billing/invoices/list', {customer: customerRecord?.customerTaxCode}]" target="_blank">{{customerRecord.totalInvoiceAmount
          | number:decimalFormat}}</a>
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        <a [routerLink]="['/billing/payments/list', {customer: customerRecord?.customerTaxCode}]" target="_blank">{{customerRecord.totalPayments
          | number:decimalFormat}}</a>
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        <a [routerLink]="['/billing/invoices/list', {status: '1', customer: customerRecord?.customerTaxCode}]" target="_blank">{{customerRecord.currentDebt
          | number:decimalFormat}}</a>
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.oldDebt | number:decimalFormat}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Amount]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        {{customerRecord.totalDebt | number:decimalFormat}}
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        <span class='comment' (click)="showThread(customerRecord.lastComments[ThreadTopicEnum.Sales]?.threadId, ThreadTopicEnum.Sales)">
          {{customerRecord.lastComments[ThreadTopicEnum.Sales]?.text}}
        </span>
        <span>{{customerRecord.lastComments[ThreadTopicEnum.Sales]?.createDate | date:dateFormat}}</span>
        <p-button type="button" class="addComment" icon="fa fa-plus-circle" (click)="showCommentEditor(customerRecord.lastComments[ThreadTopicEnum.Sales]?.threadId, customerRecord.customerId, ThreadTopicEnum.Sales)"></p-button>
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        <span class='comment' (click)="showThread(customerRecord.lastComments[ThreadTopicEnum.Manager]?.threadId, ThreadTopicEnum.Manager)">
          {{customerRecord.lastComments[ThreadTopicEnum.Manager]?.text}}
        </span>
        <span>{{customerRecord.lastComments[ThreadTopicEnum.Manager]?.createDate | date:dateFormat}}</span>
        <p-button type="button" class="addComment" icon="fa fa-plus-circle" (click)="showCommentEditor(customerRecord.lastComments[ThreadTopicEnum.Manager]?.threadId, customerRecord.customerId, ThreadTopicEnum.Manager)"></p-button>
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        <span class='comment' (click)="showThread(customerRecord.lastComments[ThreadTopicEnum.ACC]?.threadId, ThreadTopicEnum.ACC)">
          {{customerRecord.lastComments[ThreadTopicEnum.ACC]?.text}}
        </span>
        <span>{{customerRecord.lastComments[ThreadTopicEnum.ACC]?.createDate | date:dateFormat}}</span>
        <p-button type="button" class="addComment" icon="fa fa-plus-circle" (click)="showCommentEditor(customerRecord.lastComments[ThreadTopicEnum.ACC]?.threadId, customerRecord.customerId, ThreadTopicEnum.ACC)"></p-button>
      </ng-template>
    </p-column>
    <p-column [hidden]="!columnGroupsVisibility[ColumnGroupEnum.Comments]">
      <ng-template let-col let-customerRecord="rowData" pTemplate="body">
        <span class='comment' (click)="showThread(customerRecord.lastComments[ThreadTopicEnum.Debt]?.threadId, ThreadTopicEnum.Debt)">
          {{customerRecord.lastComments[ThreadTopicEnum.Debt]?.text}}
        </span>
        <span>{{customerRecord.lastComments[ThreadTopicEnum.Debt]?.createDate | date:dateFormat}}</span>
        <p-button type="button" class="addComment" icon="fa fa-plus-circle" (click)="showCommentEditor(customerRecord.lastComments[ThreadTopicEnum.Debt]?.threadId, customerRecord.customerId, ThreadTopicEnum.Debt)"></p-button>
      </ng-template>
    </p-column> -->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="20">
          {{ 'message.NoRecordsFound' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="text-align: center">
    <input
      type="number"
      min="1"
      id="page-number"
      [(ngModel)]="customPageNumber"
    />
    <p-button
      type="button"
      id="custom-pagenumber"
      (click)="onCustomPageEnter()"
      icon="fa fa-angle-double-right"
    ></p-button>
  </div>
</div>
